/* @flow */
// typecheck: ignore file
import cx from 'classnames';
import React from 'react';
import AppLayoutContentView from 'app/components/AppLayoutContentView.jsx';
import AppLayoutContentViewHeader from 'app/components/AppLayoutContentViewHeader.jsx';
import SettingsNavContainer from 'settings/containers/SettingsNavContainer.jsx';
import View from 'components/View.jsx';
import { withDocumentTitle } from 'lib/documentTitle';

import './styles/SettingsView.scss';

type Props = {
  children?: ?React$Element<*>,
  className?: ?string,
  goBack: () => void,
};

class SettingsView extends React.Component {
  props: Props;

  renderHeader() {
    return (
      <AppLayoutContentViewHeader
        title="Back"
        onRequestPrevious={this.props.goBack}
        renderPreviousButton
      />
    );
  }

  render() {
    return (
      <AppLayoutContentView
        className={cx('SettingsView', this.props.className)}
        header={this.renderHeader()}
        sidebar={<SettingsNavContainer />}>
        <View className="SettingsView-content">
          <div className="SettingsView-content-view">
            {this.props.children}
          </div>
        </View>
      </AppLayoutContentView>
    );
  }
}

export default withDocumentTitle('Settings', SettingsView);



// WEBPACK FOOTER //
// ./src/settings/components/SettingsView.jsx